module.exports = __webpack_public_path__ + "static/media/full-spa-body-massage-and-creambath.403a4142.webp";